import React from 'react';
import { isMenuItem } from "../../../components/MenuItem";
import { isMenuHeader } from "../../../components/MenuHeader";
export var addIconPaddingIfPartOfMenu = function addIconPaddingIfPartOfMenu(child, enableIconPadding) {
  var isPartOfMenu = isMenuItem(child) || isMenuHeader(child);

  if (enableIconPadding && isPartOfMenu) {
    return /*#__PURE__*/React.cloneElement(child, {
      _enableIconPadding: true
    });
  }

  return child;
};